// extracted by mini-css-extract-plugin
module.exports = {"frame":"StickiesLogo_frame__3GiJC"};